import Vue from "vue"
import vuetify from "@/plugins/vuetify"
import axios from "axios"
import VueTheMask from "vue-the-mask"
import { Table } from 'buefy'
import io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import VueQuillEditor from 'vue-quill-editor'
import DatetimePicker from 'vuetify-datetime-picker'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
 
Vue.component('datetime', Datetime);

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

import './main.scss' // import main styles
import Vuelidate from "vuelidate";

require("@/store/subscriber");

axios.defaults.baseURL = `${process.env.VUE_APP_API_LINK}/api`;

axios.interceptors.response.use((response) => response, (err) => {
  if (err.response.status == 403) {
    store.commit("LOGOUT", null);
    store.dispatch("snackbar/showHandlerSnackbar", { color: "error", text: "Session ended, please login again", show: true });
  } else if (err.response.status == 307) {
    store.commit("auth/SET_UNCOMPLETED_LEAD", err.response.data.lead_id);
    if (router.history.current.path !== `/lead/${err.response.data.lead_id}`) {
      router.push({ path: `/lead/${err.response.data.lead_id}` });
      store.dispatch("lead/loadLead", err.response.data.lead_id);
      store.dispatch("snackbar/showHandlerSnackbar", { color: err.response.data.status, text: err.response.data.message, show: true });
    }
  } else if (err.response.status == 423) {
    router.replace({ name: "Life" });
  }
  throw err;
});

export const socket = io(process.env.VUE_APP_API_LINK, {
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionAttempts: 40,
  withCredentials: false
});

Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV === "development" ? true : false,
  connection: socket,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  },
}));

Vue.use(VueTheMask);
Vue.use(Table);
Vue.use(VueQuillEditor);
Vue.use(DatetimePicker);
Vue.use(Vuelidate);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

store.dispatch("auth/verifyUser", localStorage.getItem("leadBlueberryToken"))
  .then(() => {
    new Vue({
      vuetify,
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }).catch(() => {
    localStorage.removeItem("leadBlueberryToken");

    new Vue({
      vuetify,
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  });
